<script lang="ts">
  import FeatherIcon from "svelte-feather-icon";
  import { Col, Row } from "sveltestrap";
  import Saledata from "../../../Data/ComponentData/WidgetData/Genral/SaleData.json";
    import { Sale } from "../../../utils/Constant/Constant";
</script>

<Col xl="6" class="xl-50 box-col-12">
  <div class="widget-joins card widget-arrow">
    <Row>
      {#each Saledata.saledata as saleItem}
        <Col sm="6" class="pe-0">
          <div class="media border-after-xs">
            <div class="align-self-center me-3 text-start">
              <span class="widget-t mb-1">{Sale}</span>
              <h5 class="mb-0">{saleItem.Time}</h5>
            </div>
            <div class="media-body align-self-center">
              <FeatherIcon class="font-primary" icon={saleItem.icon} />
            </div>
            <div class="media-body">
              <h5 class="mb-0">$<span class="counter">{saleItem.amount}</span></h5>
              <span class="mb-1">{saleItem.percentage}</span>
            </div>
          </div>
        </Col>
      {/each}
    </Row>
  </div>
</Col>
